import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { getImage } from "gatsby-plugin-image";

import ButtonSolid from "../Button/ButtonSolid";
import ButtonGhost from "../Button/ButtonGhost";
import CTAFullWidth from "../CTA/CTAFullWidth";

const CTA = ({ heading, headingLevel }) => {
   const data = useStaticQuery(graphql`
      {
         backgroundDesktop: file(relativePath: { eq: "repeating/cta/CTA background desktop.jpg" }) {
            childImageSharp {
               gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, quality: 100)
            }
         }
         backgroundMobile: file(relativePath: { eq: "repeating/cta/CTA mandala - mobile.jpg" }) {
            childImageSharp {
               gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, quality: 100)
            }
         }
      }
   `);

   const backgroundImages = [
      getImage(data.backgroundDesktop.childImageSharp.gatsbyImageData),
      {
         ...getImage(data.backgroundMobile.childImageSharp.gatsbyImageData),
         media: `(max-width: 767px)`,
      },
   ];

   const HeadingTag = headingLevel;

   return (
      <CTAFullWidth
         backgroundImages={backgroundImages}
         backgroundSize="contain"
         padding="pt-28 md:pt-52 pb-28 md:pb-56"
         textAlignment="text-center mx-auto"
         textMaxWidth="max-w-3xl"
      >
         <HeadingTag className="gradient-text text-6xl uppercase mb-4">{heading || "Let’s Secure Your Legacy."}</HeadingTag>
         <p className="text-lg md:text-xl mb-8">
            Connect with us for a free 15-minute consultation, or send us any questions you may have. Let’s work together to protect what you’ve
            built.
         </p>
         <div className="flex flex-col md:flex-row justify-center">
            <ButtonSolid as="button" modal="modal-contact" text="Get Started" className="mb-5 md:mb-0 md:mr-6" />
            <ButtonGhost href="tel:-619-987-3532" text="619-987-3532" />
         </div>
      </CTAFullWidth>
   );
};

export default CTA;
